"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _objectWithoutProperties = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _excluded = ["noopener"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeBase64Params = exports.encodeBase64Params = exports.openLink = void 0;
var react_native_1 = require("react-native");
var lodash_1 = require("lodash");
var json_1 = require("./json");
var schemeRe = /(.+?:)\/\//;
function openLink(_x) {
  return _openLink.apply(this, arguments);
}
function _openLink() {
  _openLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(uri) {
    var target,
      options,
      _window,
      args,
      _ref,
      _ref$noopener,
      noopener,
      opts,
      optsList,
      result,
      error,
      isSchemeSupported,
      _schemeRe$exec,
      _schemeRe$exec2,
      scheme,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          target = _args.length > 1 && _args[1] !== undefined ? _args[1] : "_blank";
          options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          if (!(react_native_1.Platform.OS === "web")) {
            _context.next = 8;
            break;
          }
          args = [new URL(uri, window.location.href).toString(), target];
          _ref = options || {}, _ref$noopener = _ref.noopener, noopener = _ref$noopener === void 0 ? false : _ref$noopener, opts = _objectWithoutProperties(_ref, _excluded);
          if (!(0, lodash_1.isEmpty)(options)) {
            optsList = (0, lodash_1.toPairs)(opts).map(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];
              return "".concat(key, ": '").concat(value, "'");
            });
            if (noopener) {
              optsList.push("noopener");
            }
            args.push(optsList.join(", "));
          }
          (_window = window).open.apply(_window, args);
          return _context.abrupt("return");
        case 8:
          _context.prev = 8;
          _context.next = 11;
          return react_native_1.Linking.openURL(uri);
        case 11:
          result = _context.sent;
          _context.next = 22;
          break;
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](8);
          error = _context.t0; // check does sheme supported to make sure the exception is about this case
          _context.next = 19;
          return react_native_1.Linking.canOpenURL(uri).catch(function () {
            return false;
          });
        case 19:
          isSchemeSupported = _context.sent;
          if (!isSchemeSupported) {
            _schemeRe$exec = schemeRe.exec(uri), _schemeRe$exec2 = _slicedToArray(_schemeRe$exec, 2), scheme = _schemeRe$exec2[1];
            error = new Error("There aren't apps installed can handle '".concat(scheme, "' scheme"));
          }
          throw error;
        case 22:
          return _context.abrupt("return", result);
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[8, 14]]);
  }));
  return _openLink.apply(this, arguments);
}
exports.openLink = openLink;
var encodeBase64Params = function encodeBase64Params(value) {
  return encodeURIComponent(btoa((0, lodash_1.isString)(value) ? value : JSON.stringify(value)));
};
exports.encodeBase64Params = encodeBase64Params;
var decodeBase64Params = function decodeBase64Params(value) {
  return (0, json_1.tryJson)(atob(decodeURIComponent(value)));
};
exports.decodeBase64Params = decodeBase64Params;